import { useEffect } from 'react';

export function useTitle(title, defaultTitle = 'Wellso') {
  useEffect(() => {
    const newTitle = title ? `${title} | ${defaultTitle}` : defaultTitle;
    const originalTitle = document.title;
    
    document.title = newTitle;
    
    return () => {
      document.title = originalTitle;
    };
  }, [title, defaultTitle]);
}

